(() => {
	document.addEventListener('focusout', function (event) {
		let matchesSimple = event.target.matches ? event.target.matches('#plt-signup-modal .simple-validation .form-control') : event.target.msMatchesSelector('#plt-signup-modal .simple-validation .form-control');
		let matchesEmail = event.target.matches ? event.target.matches('#plt-signup-modal .email-validation .form-control') : event.target.msMatchesSelector('#plt-signup-modal .email-validation .form-control');
		let matchesPassword = event.target.matches ? event.target.matches('#plt-signup-modal .password-validation .form-control') : event.target.msMatchesSelector('#plt-signup-modal .password-validation .form-control');

		if (matchesSimple) {
			validation.simpleValidation(event.target, '.simple-validation');
		}
		if (matchesEmail) {
			validation.emailValidation(event.target, '.email-validation');
		}
		if (matchesPassword) {
			validation.isPasswordValid(event.target, '.password-validation');
		}
	});

	document.addEventListener('keyup', function(event) {
		if (event.target.id == 'signup-password') {
			if (event.target.value.length > 2) {
				passwordValidation(event.target);
			}
		}
	});

	$("#plt-signup-modal").on("hidden.bs.modal", function () {
		$(".signup-form-wrapper .js-error").text("").removeClass('active');
	});

	$("#plt-signup-modal").on("show.bs.modal", function () {
		$(".signup-form-wrapper .js-error").text("").removeClass('active');
	});

	const form = document.querySelector('#plt-signup-form');
	// validation elements for password
	if (form !== null) {
		var minimalPasswordLength = 8;
		var checkLengthElement = form.querySelector('.password-validation .check-length');
		var checkNumberElement = form.querySelector('.password-validation .check-number');
		var checkUppercaseElement = form.querySelector('.password-validation .check-uppercase');
		var checkLowercaseElement = form.querySelector('.password-validation .check-lowercase');
	}


	function passwordValidation(element) {
		let value = element.value;

		validation.setValidation(checkLengthElement, validation.isMinimalLength(value, minimalPasswordLength));
		validation.setValidation(checkNumberElement, validation.containsNumbers(value));
		validation.setValidation(checkUppercaseElement, validation.containsUppercaseCharacters(value));
		validation.setValidation(checkLowercaseElement, validation.containsLowercaseCharacters(value));
	}

	$('#plt-signup-form').submit(function(event){
		event.preventDefault();

		// check if the form contains any errors before we can submit
		if (validation.hasFormErrors('#plt-signup-form')) {
			return false;
		}

		const submitButton = document.querySelector('#signup-form-submit');
		// steps
		if(document.querySelector('#sign-up-email-step') !== null) {
			var modalBody = document.querySelector('#plt-signup-modal');
			var formBody = document.querySelector('.signup-step-2 ');
			var successBody = document.querySelector('.signup-step-3');
			var errorBlock = document.querySelector('#plt-signup-form .js-error');
		}
		else {
			var modalBody = document.querySelector('#plt-signup-modal');
			var formBody = document.querySelector('.signup-form-wrapper .step-1');
			var successBody = document.querySelector('.signup-form-wrapper .step-2');
			var errorBlock = document.querySelector('.signup-form-wrapper .js-error');
		}

		if (getDeviceType() !== 'mobile' && document.querySelector(".g-recaptcha") !== null) {
			var recaptcha = grecaptcha.getResponse();
		}
		else {
			var recaptcha = '';
		}

		const csrfToken = document.querySelector('#csrfToken').value;
		let signupEmail = document.querySelector('#signup-email').value;

		var request = {
			"first_name": document.querySelector('#signup-first-name').value,
			"last_name": document.querySelector('#signup-last-name').value,
			"email": document.querySelector('#signup-email').value,
			"password": document.querySelector('#signup-password').value,
			"newsletter": document.querySelector("#signup-newsletter").checked,
			"recaptcha": recaptcha,
			"pageType": document.querySelector('#signup-page-type').value
		};

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		// set loading state on the submit button
		submitButton.classList.add('is-loading');
		submitButton.disabled = true;
		gae('customer','signup_email_submit');

		fetch("/account/auth/signup", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {
				setTimeout(function() {
					submitButton.classList.remove('is-loading');

					if (response.status == "ok") {
						marketing.trackSoftGoals(marketing.SoftGoals.AccountRegistration, 'form');
						gae('customer','signup_email_submit_ok');
						modalBody.scrollTop = 0;
						if(window.location.href.indexOf('/signup') > -1) {
							const redirectUrl = document.referrer;
							window.location.href = redirectUrl;
						}
						else {
						if(document.querySelector('#sign-up-email-step') !== null) {
							formBody.classList.add('hide');
							successBody.classList.remove('hide');
						}
						else {
							formBody.classList.add('move-out');
							successBody.classList.add('move-in');
						}
						modalBody.style.height = successBody.clientHeight + "px";
						modalBody.style.overflow = 'hidden';

						if(document.querySelector('#sign-up-confirmation-step') !== null) {
							var closeButton = document.querySelector('#sign-up-confirmation-step .close');
						}
						else {
							var closeButton = document.querySelector('#plt-signup-modal .close');
						}
						// check if it exists so if the form is in a modal or not
						if (closeButton !== null) {
							const backdrop = document.querySelector('.modal-backdrop-light');
							closeButton.classList.add('js-close-reload');
							backdrop.classList.add('js-close-reload');
							document.addEventListener('click', function (event) {
								if (event.target.matches('.js-close-reload')) {
									window.location.reload();
								}
							});
						}


						form.reset();
						}
					}
					else {
						let error = response.error;
						if(error == 'Account already exists') {
							$('#plt-signup-modal').modal('hide');
							$('#plt-login-modal').modal('show');
							let errorContainer = document.querySelector('.login-form-wrapper .js-error');
							errorContainer.classList.add('active');
							errorContainer.innerHTML = error;
							document.querySelector('#login-email').value = signupEmail;
						}
						else {
							errorBlock.classList.add('active');
							submitButton.disabled = false;
							errorBlock.innerHTML = error;
						}
						gae('customer','signup_email_submit_error');
					}
				}, 1000);


			})
			.catch(function(error) {
				console.error('Error:', error);
			});
	});

	$('.js-modal-fill-data').click(function(event){
		event.preventDefault();

		const csrfToken = document.querySelector('#csrfToken').value;

		const params = {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		const token = getUrlParameter('token');
		fetch("/account/auth/signup?token=" + token + "&modal", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {
				if(response.status == "ok"){
					document.querySelector('#signup-first-name').value = response.name;
					document.querySelector('#signup-last-name').value = response.lastName;
					document.querySelector('#signup-email').value = response.email;
				}
			});
	});
	if(document.querySelector('#signup-email-button') !== null){
		var signupEmailButton = document.querySelector('#signup-email-button');
		var backButton = document.querySelector('.bttn--back');
		backButton.addEventListener('click', event => {
			var container = backButton.closest(".signup-step-2");
			container.classList.add("hide");
			var step1 = signupEmailButton.closest(".step-1");
			step1.classList.remove("hide");
		});
		signupEmailButton.addEventListener('click', event => {
			var container = signupEmailButton.closest(".step-1");
			container.classList.add("hide");
			var step2 = document.querySelector('.signup-step-2');
			step2.classList.remove("hide");
		});
	}
})();
